import { loadable } from 'jotai/utils'
import { atom } from 'infrastructure/state/jotai.wrapper'
import { doAdminQueries, IQueryInfo } from '../providers/mutations'

async function doAdminIntrospection() {
  const queryInfo: IQueryInfo = {
    resourceData: {
      key: '__schema',
      fields: [{ queryType: ['name', { fields: ['name', 'description'] }] }],
    },
    params: {},
  }
  return doAdminQueries<{
    queryType: {
      fields: {
        description: string
        name: string
      }[]
    }
  }>([queryInfo])
}

const adminIntrospectionAtom = loadable(
  atom(async () => {
    return doAdminIntrospection()
  }),
)

interface IQuery {
  name: string
  description: string
}

interface IQueries {
  queries: IQuery[]
  mutations: IQuery[]
  other: IQuery[]
}

export const adminIntrospectionQueriesAtom = atom((get) => {
  const resp = get(adminIntrospectionAtom)
  if (resp.state !== 'hasData' || !resp.data.data) {
    return
  }
  return resp.data.data.__schema.queryType.fields.reduce<IQueries>(
    (acc, query) => {
      switch (true) {
        case query.description.startsWith('QUERY:'): {
          acc.queries.push(query)
          break
        }
        case query.description.startsWith('MUTATION:'): {
          acc.mutations.push(query)
          break
        }
        default: {
          acc.other.push(query)
          break
        }
      }
      return acc
    },
    {
      queries: [],
      mutations: [],
      other: [],
    },
  )
})
